<template>
  <sidebar title="Queries">
    <nav>
      <div>
        <router-link :to="{path: `/clients/${client_id}/projects/${project_id}/searches`}">Queries</router-link>
        <router-link :to="{ path: `/clients/${client_id}/projects/${project_id}/searches/create`}" class="action-button">
          <i class="far fa-plus-circle"/>
        </router-link>
      </div>
      <div>
        <router-link :to="{path: `/clients/${client_id}/projects/${project_id}/searches/group_library`}">Groups</router-link>
        <router-link :to="{path: `/clients/${client_id}/projects/${project_id}/searches/group_library/create`}" class="action-button">
          <i class="far fa-plus-circle"/>
        </router-link>
      </div>
      <div>
        <router-link :to="{path: `/clients/${client_id}/projects/${project_id}/tags`}">Tags</router-link>
        <router-link :to="{path: `/clients/${client_id}/projects/${project_id}/tags/create`}" class="action-button">
          <i class="far fa-plus-circle"/>
        </router-link>
      </div>
<!--      <div><a @click.prevent="settingsLink">Settings</a></div>-->
    </nav>
  </sidebar>
</template>

<script>
import sidebar from '../../sidebar.vue'
export default {
  name: "landing-sidebar",

  computed: {
    client_id() { return this.$store.state.booleanSearch.client_id },
    project_id() { return this.$store.state.booleanSearch.project_id },
  },

  methods: {
    settingsLink() {
      console.log('settingsLink')
    }
  },

  components: {
    sidebar
  }
}
</script>